
const BorderBox = ({position}) => {
	return (
		<>
			<rect
				className="border-box"
				x={position[0] - 5}
				y={position[1] - 5}
				width="10"
				height="10"
			/>
			<line
				className="border-box"
				x1={position[0] - 5}
				y1={position[1] - 5}
				x2={position[0] + 5}
				y2={position[1] + 5}
			/>
			<line
				className="border-box"
				x1={position[0] + 5}
				y1={position[1] - 5}
				x2={position[0] - 5}
				y2={position[1] + 5}
			/>
		</>
	)
}

export default BorderBox
